var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"keyword-tag"},[_c('span',{staticClass:"inner"},[_c('span',[_vm._v(_vm._s(_vm.word))]),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('remove')}}},[_c('v-icon',{attrs:{"size":"11"}},[_vm._v("mdi-close")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }